import { AnyTranslationsFn } from "@/types/locale";
import { MenuItem } from "@/types/ui";
import { UseRouteInfo } from "@hooks/pages/use-route-info";
import { buildSidebarMenuItem } from "@hooks/use-feature-menu";
import routes from "@features/routes";
import { removeUndefined } from "@lib/common";
import { AccessToken, UserTokenValue } from "@features/auth/types/access-token";

export const appTools = {
  /**
   * Generates an array of menu items to be displayed in a sidebar based on provided routing and localization data.
   *
   * @param {AnyTranslationsFn} localeAs - A function to handle translations for localized strings.
   * @param {UseRouteInfo} pageInfo - Information about the current route, typically used to determine active states or page contexts.
   * @param {UserTokenValue} user - The user token value containing user information.
   * @param {boolean} isPrivateMode - Indicates whether the application is in private mode.
   * @param {boolean} showDashboardWithWorkspaces - Shows dashboard menu item when user workspaces are available.
   * @returns {MenuItem[]} An array of sidebar menu items.
   */
  buildSidebarMenuItems: (
    localeAs: AnyTranslationsFn,
    pageInfo: UseRouteInfo,
    user?: UserTokenValue,
    isPrivateMode?: boolean,
    showDashboardWithWorkspaces?: boolean,
  ): MenuItem[] =>
    removeUndefined([
      AccessToken.isGlobalAdmin(user) && isPrivateMode
        ? buildSidebarMenuItem({
            localeAs,
            page: routes.reports.pages.report_server,
            pageInfo,
          })
        : undefined,
      AccessToken.isGlobalAdmin(user) && isPrivateMode
        ? buildSidebarMenuItem({
            localeAs,
            page: routes.pipeline.pages.pipelines,
            pageInfo,
          })
        : undefined,
      !isPrivateMode && showDashboardWithWorkspaces
        ? buildSidebarMenuItem({
            localeAs,
            page: routes.application.pages.dashboard,
            pageInfo,
          })
        : undefined,
      isPrivateMode
        ? undefined
        : buildSidebarMenuItem({
            localeAs,
            page: routes.proposals.pages.speaker_area_proposals,
            pageInfo,
          }),
    ]) as MenuItem[],
};
